var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{staticClass:"d-none d-md-block header",attrs:{"color":"primary","elevation":"0","height":"110px"}},[_c('header-base',{staticClass:"p-0"})],1),_c('v-main',[_c('SnackBar'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }